"use strict";
/**
 * Envelope every RESTOR endpoint returns (TZ §43).
 *
 * The backend never returns a bare object: a response interceptor wraps every
 * successful handler result in {@link ApiSuccess} and an exception filter turns
 * every thrown error into {@link ApiFailure}. Clients can therefore branch on a
 * single `success` flag instead of guessing from the HTTP status.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_PAGE_SIZE = exports.DEFAULT_PAGE_SIZE = void 0;
exports.isApiSuccess = isApiSuccess;
exports.DEFAULT_PAGE_SIZE = 20;
exports.MAX_PAGE_SIZE = 100;
/** Narrowing helper so clients get `data` typed without a manual cast. */
function isApiSuccess(response) {
    return response.success === true;
}
//# sourceMappingURL=api.js.map